import { del, get, post, put } from '../../client';
import { shouldLogApiCalls } from '../../config';

export const listAllAutomatisations = async () => {

    return get(`/automatisation?page_size=999999`);
}

export const listPaginatedAutomatisations = async (page, pageSize, is_ghost, tags, searchTerm, sortBy, sortOrder) => {
    const tagsParam = Array.isArray(tags) && tags.length > 0 ? JSON.stringify(tags) : '';
    const searchParam = searchTerm ? `&search_term=${encodeURIComponent(searchTerm)}` : '';
    const sortParam = sortBy && sortOrder ? `&sort_by=${encodeURIComponent(sortBy)}&sort_order=${encodeURIComponent(sortOrder)}` : '';
    return get(`/automatisation?page_at=${page}&page_size=${pageSize}&is_campaign=false&is_ghost=${is_ghost}${tagsParam ? `&tags=${encodeURIComponent(tagsParam)}` : ''}${searchParam}${sortParam}`);
}

export const fetchAutomatisation = async (automatisationId) => {
    return get(`/automatisation?automatisation_id=${automatisationId}`);
}

export const fetchAutomatisationSteps = async (automatisationId) => {
    return get(`/automatisation/${automatisationId}/step`);
}

export const updateAutomatisationStep = async (automatisationId, step) => {
    return put(`/automatisation/${automatisationId}/step`, step);
}

export const createAutomatisationStep = async (automatisationId, step) => {
    return post(`/automatisation/${automatisationId}/step`, step);
}

export const deleteAutomatisationStep = async (automatisationId, stepId) => {
    return del(`/automatisation/${automatisationId}/step/${stepId}`);
}

export const updateAutomatisation = async (automatisation) => {
    return put(`/automatisation`, automatisation);
}

export const deleteAutomatisation = async (automatisationId) => {
    return del(`/automatisation/${automatisationId}`);
}

export const createAutomatisation = async (automatisation) => {
    return post(`/automatisation`, automatisation);
}

export const listPaginatedCampaigns = async (page, pageSize, tags, searchTerm, sortBy, sortOrder) => {
    const tagsParam = Array.isArray(tags) && tags.length > 0 ? JSON.stringify(tags) : '';
    const searchParam = searchTerm ? `&search_term=${encodeURIComponent(searchTerm)}` : '';
    const sortParam = sortBy && sortOrder ? `&sort_by=${encodeURIComponent(sortBy)}&sort_order=${encodeURIComponent(sortOrder)}` : '';
    return get(`/automatisation?page_at=${page}&page_size=${pageSize}&is_campaign=true${tagsParam ? `&tags=${encodeURIComponent(tagsParam)}` : ''}${searchParam}${sortParam}`);
}

export const runCampaign = async (event, clientKey) => {
    return post(`/event/track`, { name: event }, { headers: { "Client-Key": clientKey } });
}

export const stopCampaign = async (automatisationId) => {
    return del(`/automatisation/${automatisationId}/run`);
}

export const copyAutomatisation = async (automatisationId) => {
    return post(`/automatisation/${automatisationId}/copy`);
}